<template>
  <v-app class="animation-stop">

    <v-app-bar v-show="isInitialized" app color="primary" dark>
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>

      <span class="title ml-3 mr-5">パートナー企業 データベース</span>

      <v-text-field
              v-if="canSearch"
              solo-inverted
              flat
              hide-details
              label="検索"
              prepend-inner-icon="mdi-magnify"
              v-model="search_query"
              @keydown.enter="onSearchEnter"
      ></v-text-field>

      <v-spacer></v-spacer>

    </v-app-bar>

    <v-navigation-drawer v-show="isInitialized" v-model="drawer" app clipped color="grey lighten-4">
      <v-list dense class="grey lighten-4">
        <template v-for="(item, i) in items">
          <v-row
                  v-if="item.heading"
                  :key="i"
                  align="center"
          >
            <v-col cols="6">
              <v-subheader v-if="item.heading">
                {{ item.heading }}
              </v-subheader>
            </v-col>
            <v-col
                    cols="6"
                    class="text-right"
            >
              <v-btn
                      small
                      text
              >edit</v-btn>
            </v-col>
          </v-row>
          <v-divider
                  v-else-if="item.divider"
                  :key="i"
                  dark
                  class="my-4"
          ></v-divider>

          <v-list-item
                  v-else
                  :key="i"
                  link v-on:click="onMenuClick(item)">

            <v-list-item-action>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-action>

            <v-list-item-content>
              <v-list-item-title class="grey--text">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item-content>

          </v-list-item>

        </template>
      </v-list>
    </v-navigation-drawer>

    <v-main class="">
      <div class="fill-height pa-1 pa-sm-3 pa-md-5 pa-lg-9">
        <router-view v-if="isInitialized"></router-view>
        <login v-if="needLogin" @login="onStartup"></login>
      </div>
    </v-main>

    <v-footer app>
      <!-- -->
    </v-footer>

    <v-snackbar v-model="message_snackbar.show" timeout="2000" top color="info">{{message_snackbar.message}}</v-snackbar>
    <v-snackbar v-model="error_message_snackbar.show" timeout="2000" top color="error">{{error_message_snackbar.message}}</v-snackbar>

  </v-app>
</template>

<script>

  import Common from "./components/Common";
  import LoginSupport from "./components/LoginSupport";
  import BasicInfoAPI from "./apis/BasicInfoAPI";
  import Login from "./views/login/Login";
  import UserAPI from "@/apis/UserAPI";
  import {UnauthorizedError} from "@/apis/Api";

  export default {
    name: 'App',
    mixins:[Common,LoginSupport],
    components: {
      Login
    },
    data: () => ({
      isInitialized:false,

      needLogin:false,
      canSearch:false,

      drawer: null,
      items: [
        { icon: '', text: 'ホーム' , link:{ name: 'home' } },
        { icon: '', text: '仕入先検索' , link:{ name: 'supplier_search' } },
        { icon: '', text: 'ランキング' , link:{ name: 'user_ranking' } },
        { divider: true },
        { icon: '', text: 'Account' },
        { icon: '', text: 'Logout' ,action:"sign_out" },
      ],
      search_query:"",

      message_snackbar:{
        show:false,
        message:"",
      },
      error_message_snackbar:{
        show:false,
        message:"",
      },
    }),
    computed: {
    },
    mounted: function () {
      this.$eventHub.$off('show-snackbar',  this.onShowSnackbar)
      this.$eventHub.$on('show-snackbar', this.onShowSnackbar)

      // スタートアップ開始
      this.onStartup();
    },
    beforeDestroy() {
      this.$eventHub.$off('show-snackbar', this.onShowSnackbar);
    },
    watch: {
      '$route':function(to, from) {
        this.canSearch = this.$router.currentRoute.path !== '/search';
      },
    },
    methods: {
      onMenuClick(menuItem){
        if (menuItem.action){
          if (menuItem.action === "sign_out"){
            this.cognitoSignOut()
            this.isInitialized = false;
            this.needLogin = true;
          }
        }
        if (menuItem.link){
          this.$router.push(menuItem.link)
        }
      },
      onSearchEnter(event){
        //console.log("onConditionEnter keyCode=" + event.keyCode)
        // 通常のEnterはkeyCode = 13
        // 日本語入力中のEnterはkeyCode = 229を返す
        if (event.keyCode === 13){
          if (this.search_query){
            this.onSearchClick();
          }
        }
      },
      onSearchClick(){
        //window.logger.log("onSearchClick search_query " + this.search_query)
        //this.$router.push({ name: 'supplier_search', params: { search_query: this.search_query } })
        this.$router.push({ path: 'search', query: { q: this.search_query } })
      },

      onShowSnackbar(param){

        if (param.type === "error"){
          this.error_message_snackbar.message = param.message;
          this.error_message_snackbar.show = true;
        }
        else {
          this.message_snackbar.message = param.message;
          this.message_snackbar.show = true;
        }

      },

      // -------------------------------------
      // スタートアップフロー
      // mountから呼ばれる
      // loginされた後も呼ばれる
      // -------------------------------------
      onStartup(){
        console.log("onStartup")

        this.needLogin = false;
        this.isInitialized = false;


        // 1.ログイン状態の確認
        //   自身のプロファイル情報を取得してみる。
        //   OK 次のステップへ
        //   NG ログイン画面遷移 → login後に再度呼び出されれる
        //
        // 2.仕入先DBの登録状態を確認
        //
        //
        // 3.基本情報取得
        //   ・サーバステータス
        //   ・工程マスタ
        //
        // 4.routerにより画面起動


        // Profileの取得
        let apiOption = {
          onUnauthorized: null,
        };
        let pmsMyProf = UserAPI.getMyProfile(apiOption)
            .then(res => {
              console.log("profile",res);
              let prof = res;
              //let prof = {
              //  name:"テストユーザ",
              //  userId:1,
              //};
              this.$store.commit('setProfile', prof);
              window.logger.info("プロフィールを設定。",prof);
              return true;
            });//.catch(e => false)


        //this.initCognito();

        Promise.resolve()
                .then(a => pmsMyProf)
                //.then(a => {
                //  if (!a){
                //    // ログイン画面を表示する
                //    this.needLogin = true;
                //    throw Error("need_login")
                //  }
                //})
                .then(a => this.queryBasicInfo())
                .then(a => {
                    this.isInitialized = true;
                })
                .catch(e => {
                  console.log("スタートアップフローで例外がcatchされました。",e);
                  if (e instanceof UnauthorizedError){
                    console.log("スタートアップフローで認証に失敗しました。ログイン画面へ遷移します。");
                    // ログイン画面を表示する
                    this.needLogin = true;
                  }

                  
                })

        //this.cognitoSignIn("masaru_takahashi","My191a")

      },

      queryBasicInfo(){

        let self = this;

        let pmsProcessing = BasicInfoAPI.getProcessingGroups()
            .then(res => {
              self.$store.commit('setProcessingsGroups', res);
            })

        let pmsMaterial = BasicInfoAPI.getMaterials()
            .then(res => {
              self.$store.commit('setMaterials', res);
            })

        let pmsMaterialFace = BasicInfoAPI.getMaterialFaces()
                .then(res => {
                  self.$store.commit('setMaterialFaces', res);
                })

        let pmsEquipments = BasicInfoAPI.getEquipments()
            .then(res => {
              self.$store.commit('setEquipments', res);
            })

        let pmsItemGroups = BasicInfoAPI.getItemGroups()
            .then(res => {
              self.$store.commit('setItemGroups', res);
            })

        let pmsSizeItems = BasicInfoAPI.getSizeItems()
            .then(res => {
              self.$store.commit('setSizeItems', res);
            })

        let pmsStaffs = BasicInfoAPI.getStaffs()
            .then(res => {
              self.$store.commit('setStaffs', res);
            })



        return Promise.resolve()
            .then(a => Promise.all([
                pmsProcessing, pmsMaterial, pmsMaterialFace,pmsEquipments,pmsItemGroups,pmsSizeItems,pmsStaffs]))

      }


    },
  };
</script>
<style>
  #keep .v-navigation-drawer__border {
    display: none
  }
  .animation-stop {
    transition: transform 0s!important;
  }
</style>
